//April 2019:  See ErrorMessage.js

export const hasSigninError = (errorMessages) => {
    if (!errorMessages) {
        return false;
    }
    if (! errorMessages.global) {
        return false;
    }
    if (errorMessages.global.length == 0) {
        return false;
    }
    var signinErrors = errorMessages.global.filter(function(err) {
        return err.code.startsWith("logon");
    });
    return signinErrors.length > 0;
}
